import { Link } from 'react-router-dom'
import { isNativeApp } from '../lib/native'

const UPDATED = '16 October 2026'

/** Privacy policy for the website and the iOS app. Linked from the home page and the App Store listing. */
export default function Privacy() {
  return (
    <main className={`landing${isNativeApp ? ' landing-app' : ''} prose`}>
      <header className="landing-head">
        <div>
          <h1>Privacy Policy</h1>
          <p className="muted">Mala Racing · last updated {UPDATED}</p>
        </div>
        <Link className="button secondary small-button" to="/">
          ← Home
        </Link>
      </header>

      <p>
        Mala Racing ("we", "the app") is a tool for analysing AiM Solo 2 lap-timer data, available at mala-racing.com and
        as an iOS app. This policy explains what information the app handles and why.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>
          <strong>Account email address.</strong> Only if you create an account. It is used to sign you in and to send
          verification codes. Accounts are optional: Race Studio works without one.
        </li>
        <li>
          <strong>Session files you upload.</strong> If you choose "upload to my repo", the AiM session files (.xrk/.xrz)
          and any notes you add are stored in a private folder that only your account can read. They contain lap times,
          speed, GPS position and sensor data recorded by your logger.
        </li>
        <li>
          <strong>Saved workspace.</strong> Which sessions and laps you had open, so they reopen next time. Stored on your
          device, and in your repo when signed in.
        </li>
      </ul>

      <h2>What we do not collect</h2>
      <ul>
        <li>No analytics, advertising identifiers, tracking or third-party SDKs that profile you.</li>
        <li>No location data from your phone. GPS data comes only from the logger files you open or upload.</li>
        <li>No contacts, photos or other personal data.</li>
      </ul>

      <h2>Local files and the Solo 2</h2>
      <p>
        Files you open from your device are parsed on the device and cached there so they reopen after a restart. The iOS
        app can connect to your Solo 2 over its own Wi-Fi hotspot to list and download sessions; this uses the local
        network only and sends nothing elsewhere. Downloaded files stay on your phone unless you upload them.
      </p>

      <h2>Where data is stored and who can see it</h2>
      <p>
        Accounts and uploaded files are stored with Amazon Web Services in the United States (Amazon Cognito and Amazon
        S3). Uploaded files are private to your account; we do not share, sell or use them for anything other than showing
        them back to you. Operators of the service can access stored data only for maintenance and support.
      </p>

      <h2>Deleting your data</h2>
      <p>
        You can delete individual files from "My repo" at any time. "Delete my account" under <Link to="/account">My
        Account</Link> permanently removes your account, every uploaded file and note, and the saved workspace. Deletion is
        immediate; backups of deleted files expire within 30 days.
      </p>

      <h2>Children</h2>
      <p>The service is not directed at children under 13 and we do not knowingly collect their data.</p>

      <h2>Changes</h2>
      <p>If this policy changes, the date at the top is updated and material changes are announced on the home page.</p>

      <h2>Contact</h2>
      <p>
        Questions about privacy or your data: see the <Link to="/support">support page</Link>.
      </p>

      <p className="muted small">
        <Link to="/">Home</Link>
      </p>
    </main>
  )
}
